export enum ProductLine {
  Workplace = 'Workplace',
  Lifecycle = 'Lifecycle',
  Assess = 'Assess'
}
